<template>
  <div>
    <SuccessFlash />

    <!-- Basic data -> name, address -->
    <div class="section-border">
      <div class="grid grid-cols-12 gap-4">
        <div class="input-group col-span-12 sm:col-span-12">
          <label for="region_name"> Name </label>
          <input
            type="text"
            v-model="form.name"
            name="name"
            id="region_name"
          />
          <p
            v-if="getErrors('name', form)"
            class="input-error"
          >
            {{ getErrors('name', form) }}
          </p>
        </div>

        <div class="input-group col-span-12 sm:col-span-12">
          <label for="region_address"> Address </label>
          <input
            type="text"
            v-model="form.address"
            name="address"
            id="region_address"
          />
          <p
            v-if="getErrors('address', form)"
            class="input-error"
          >
            {{ getErrors('address', form) }}
          </p>
        </div>

        <div class="input-group col-span-12 sm:col-span-12">
          <label for="region_location_id"> Location </label>
          <select
            v-model="form.location_id"
            name="region_location_id"
          >
            <option :value="null">Select a location</option>
            <option
              v-for="(location, key) in locations"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
          <p
            v-if="getErrors('location_id', form)"
            class="input-error"
          >
            {{ getErrors('location_id', form) }}
          </p>
        </div>

        <div class="input-group col-span-12 sm:col-span-12">
          <label for="region_address"> Minimum Order </label>
          <input
            type="text"
            v-model="form.min_amount"
            v-maska="'#*.##'"
            name="min_amount"
          />
          <p
            v-if="getErrors('min_amount', form)"
            class="input-error"
          >
            {{ getErrors('min_amount', form) }}
          </p>
        </div>

        <div class="input-group col-span-12 sm:col-span-12">
          <label for="region_address"> Delivery Fee </label>
          <input
            type="text"
            v-model="form.delivery_fee"
            v-maska="'#*.##'"
            name="delivery_fee"
          />
          <p
            v-if="getErrors('delivery_fee', form)"
            class="input-error"
          >
            {{ getErrors('delivery_fee', form) }}
          </p>
        </div>
      </div>

      <div class="pt-4">
        <div class="flex justify-end">
          <button
            type="button"
            @click.prevent="save"
            :disabled="form.processing"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>

    <!-- Addresses -->
    <div class="section-border">
      <p
        v-if="getErrors('addresses', form)"
        class="input-error"
      >
        {{ getErrors('addresses', form) }}
      </p>
      <Addresses
        :addresses="region.addresses"
        @update:addresses="addressesUpdated"
      />
    </div>

    <!-- Schedule -->
    <div class="section-border">
      <p
        v-if="getErrors('schedule', form)"
        class="input-error"
      >
        {{ getErrors('schedule', form) }}
      </p>
      <DeliverySchedule
        :schedule="region.schedule"
        @update:schedule="scheduleUpdated"
      />
    </div>
  </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3'
import checksErrors from '@/Mixins/checksErrors'
import SuccessFlash from '@/Partials/Alerts/SuccessFlash'
import Addresses from '@/Partials/Regions/Addresses'
import DeliverySchedule from '@/Partials/Regions/DeliverySchedule'

export default {
  props: {
    region: {
      type: Object,
      required: true
    }
  },

  mixins: [checksErrors],

  components: {
    SuccessFlash,
    Addresses,
    DeliverySchedule
  },

  data() {
    return {
      form: {
        id: null,
        location_id: null,
        name: null,
        address: null,
        min_amount: null,
        delivery_fee: null,
        addresses: [],
        schedule: []
      },
      enabled: false
    }
  },

  created() {
    this.form = useForm({
      ...Object.assign({}, this.form),
      ...{
        id: this.region.id,
        location_id: this.region.location_id,
        name: this.region.name,
        min_amount: this.region.min_amount,
        delivery_fee: this.region.delivery_fee,
        address: this.region.address,
        addresses: this.region.addresses,
        schedule: this.region.schedule
      }
    })
  },

  computed: {
    locations() {
      if (!this.$page.props.auth.locations || !this.$page.props.auth.locations.data) {
        return []
      }

      return this.$page.props.auth.locations.data
    }
  },

  methods: {
    save() {
      this.form
        .transform((data) => {
          if (!data.password) {
            delete data.password
          }

          return data
        })
        .put(this.route('regions.update', { region: this.region.id }), {
          onFinish: () => {
            this.$emit('update:region', Object.assign({}, this.form))
          }
        })
    },
    addressesUpdated(addresses) {
      this.form.addresses = addresses
    },
    scheduleUpdated(schedule) {
      this.form.schedule = schedule
    }
  }
}
</script>
